import { Component, Input, OnInit } from '@angular/core';
import { RolesService } from '../../../services/roles.service';
import { RoleDetailDTO, RolePermissionDTO } from '../../../interfaces/roles.interfaces';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { RevokeRolePermissionRequestDTO } from '../../../interfaces/permission.interface';
import Swal from 'sweetalert2';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AssignRolePermissionsModalComponent } from '../../modals/assign-role-permissions-modal/assign-role-permissions-modal.component';

@Component({
  selector: 'app-role-detail',
  templateUrl: './role-detail.component.html',
  styleUrls: ['./role-detail.component.scss']
})
export class RoleDetailComponent implements OnInit{

   @Input()
  public roleId: number;
  public roleDetail: RoleDetailDTO;

  public displayColumns = [
    'selection',
    'name',
  ];

  // Datasource de tabla de permisos
  public dataSource: MatTableDataSource<RolePermissionDTO> = new MatTableDataSource([]);

  public permissionSelection = new SelectionModel<RolePermissionDTO>(true, [], false, (p1, p2) => p1.id === p2.id);

  constructor(private roleService: RolesService,
    private dialog: MatDialog){

  }
  ngOnInit(): void {
    this.getRoleDetail(this.roleId);
  }

  getRoleDetail(id: number): void {
    this.roleService.getRoleById(id)
    .subscribe({
      next:(res) => {
        this.roleDetail = res;
        this.setPermissionDataset(res.permissions);
      }
    })
  }

  isAllPermissionsSelected(): boolean {
    const numSelected = this.permissionSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllPermissions(){
    if(this.isAllPermissionsSelected()){
      this.permissionSelection.clear();
      return;
    }
    this.permissionSelection.select(...this.dataSource.data);
  }

  private setPermissionDataset(permissions: Array<RolePermissionDTO>){
    this.dataSource = new MatTableDataSource(permissions);
  }

  clickRevokePermissions(){
    Swal.fire({
      title: '¿Estás seguro que desea quitar estos permisos?',
      icon: 'question',
      confirmButtonText: 'Si',
      denyButtonText: 'No',
      showDenyButton: true,
    }).then((m) => {
      if(m.isConfirmed) {
        this.revokePermissions();
      }
    })
  }

  revokePermissions(){
    const selectedPermissionsId = this.permissionSelection.selected.map(p => p.id);
    const request: RevokeRolePermissionRequestDTO = {
      roleId: this.roleId,
      permissionsId: selectedPermissionsId
    };
    this.roleService.revokeRolePermissions(request)
    .subscribe({
      next:(res) => {
        this.permissionSelection.clear();
        this.getRoleDetail(this.roleId);
        Swal.fire({
          title: 'Permisos quitados',
          icon: 'success'
        })
      },
      error: (err) => {
        Swal.fire({
          title: err.error.resultMessage,
          icon: 'error'
        });
      }
    });
  }

  openAssignPermissions() {
    const dialogConfig: MatDialogConfig = {
      disableClose: false,
      width: '50vw',
      height: '450px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: this.roleId
    };
    const dialogRef = this.dialog.open(AssignRolePermissionsModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      res => {
        if(res) this.getRoleDetail(this.roleId);
      }
    )
  }

}
